import { getTranslation, Languages } from 'common/modules/translations';
import {
	BookingPaymentState,
	BookingPreparationState,
	BookingState,
	getBookingPaymentState,
	getBookingPreparationState,
	getBookingPrice,
	getBookingState,
	getCustomerName,
	getBookingEndDate,
	getBookingDeliveryId,
	getProductsIncludedInBooking,
} from 'common/modules/bookings';
import { ById, OrderInfo, ProductApi } from 'common/types';
import { TFunction } from 'react-i18next';

export interface BookingsTableRow {
	id: string;
	created: string;
	completed: string | null;
	customer: string;
	state: BookingState;
	paymentState: BookingPaymentState;
	preparationState: BookingPreparationState;
	includedProductNames: string[];
	price: number;
	startDate: string;
	endDate: string | null;
	deliveryOptionId: string;
}

export const bookingToBookingsTableRow = (deps: {
	t: TFunction;
	lang: Languages;
	stockProductsById: ById<ProductApi>;
}) => (booking: OrderInfo): BookingsTableRow => {
	return {
		id: booking.id,
		created: booking.created,
		completed: booking.endDateReturned,
		customer: getCustomerName(booking),
		state: getBookingState(booking),
		paymentState: getBookingPaymentState(booking),
		preparationState: getBookingPreparationState(booking),
		price: getBookingPrice(booking),
		includedProductNames: getProductsIncludedInBooking(
			booking,
			deps.stockProductsById,
		).map((product) => getTranslation(product.name, deps.lang)),
		startDate: booking.startDate,
		endDate: getBookingEndDate(booking),
		deliveryOptionId: getBookingDeliveryId(booking),
	};
};
